const updateFunc = (controlData) => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;

  const tp = sensitivity;
  const fn = 100 - sensitivity;
  const calculatedData = {};
  calculatedData.tp = tp;
  calculatedData.fn = fn;

  return calculatedData;
};

export default updateFunc;
